import { render, staticRenderFns } from "./ActivityGdpr.vue?vue&type=template&id=0fc64793&scoped=true&"
import script from "./ActivityGdpr.vue?vue&type=script&lang=js&"
export * from "./ActivityGdpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc64793",
  null
  
)

export default component.exports